import { render } from "./DashboardProjetos.vue?vue&type=template&id=2a17c7dc&scoped=true"
import script from "./DashboardProjetos.vue?vue&type=script&lang=js"
export * from "./DashboardProjetos.vue?vue&type=script&lang=js"

import "./DashboardProjetos.vue?vue&type=style&index=0&id=2a17c7dc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a17c7dc"]])

export default __exports__